import labelsJson from './data/region-tag-labels.json';

/**
 * TEC-482: display labels for regionTags facet values. Without this, the search filter shows
 * raw gazetteer place ids (e.g. "658225") for city/admin1/country entries instead of "Helsinki"
 * — only continent codes and recruiting-region codes were ever human-readable on their own.
 *
 * Generated from the same checked-in seed data the gazetteer itself is built from
 * (scripts/data/geonames/*.json, scripts/data/recruiting-regions.json) — see that generation
 * inline in this file's git history / TEC-482 for the exact script, re-run it by hand if the
 * seed data changes.
 *
 * Known limitation, not yet fixed: this is a single label per value, not per-locale (no
 * "Helsingfors" for Swedish, no localized country names — GeoNames' basic country file is
 * English-only, a gap already documented in scripts/data/geonames/README.md). Wiring real
 * per-locale labels through means threading `locale` through extractFacetsFromSearchResults and
 * its ~6 call sites — a bigger, separate change than this fix. Continents and recruiting
 * regions already have real per-locale data on hand (gazetteer-continents.ts,
 * recruiting-regions.json) for whenever that's worth doing.
 */
const LABELS = labelsJson as Record<string, string>;

/** Falls back to the raw value when unknown — never throws, never shows nothing. */
export function getRegionTagLabel(value: string): string {
  return LABELS[value] ?? value;
}
